import Engineer from '../../assets/Hands_Of_Contemporary_Engineer_With..._original_438132.jpg';

const REASONS = [
    {
        number: '01',
        title: '30+ years of experience',
        description: 'Founded in 1993 by Jim Truitt — a board member of the National Institute of Steel Detailers and an active advocate for quality and training in the industry.',
    },
    {
        number: '02',
        title: 'Certified by the bodies that matter',
        description: 'AISC member. NISD Class I & II Detailers. SDS2 Certified. Every drawing we ship reflects the standards your project will be measured against.',
    },
    {
        number: '03',
        title: 'Modern software stack',
        description: 'SDS2 since 1998, Tekla PowerFab integration, BIM coordination, and direct output of CNC / NC1 / DSTV / DXF and KSS files for your equipment.',
    },
    {
        number: '04',
        title: 'Complex projects are our default',
        description: 'Commercial high-rises, industrial plants, public works, architectural metals. If it\'s complicated, that\'s exactly the work we want.',
    },
];

const PROCESS = [
    { step: 'Quote', detail: 'Send us drawings or RFP — we respond with scope and timeline within 48 hours.' },
    { step: 'Model', detail: 'We build the project in SDS2 and coordinate with your design team.' },
    { step: 'Review', detail: 'Drawings are reviewed in-house against AISC standards and your shop\'s preferences.' },
    { step: 'Deliver', detail: 'Shop drawings, erection plans, and machine-ready outputs delivered on schedule.' },
];

export const WhyUs = () => (
    <section className="relative py-20 md:py-28 bg-navy-900 text-white overflow-hidden">
        <div className="absolute inset-0 opacity-10">
            <img src={Engineer} alt="" aria-hidden="true" className="w-full h-full object-cover" />
        </div>
        <div className="absolute inset-0 bg-gradient-to-r from-navy-950 to-navy-900/80" />

        <div className="relative container-px mx-auto max-w-7xl">
            <div className="max-w-3xl mb-16">
                <p className="text-sm font-semibold text-accent uppercase tracking-[0.2em] mb-4">Why Rocky Point</p>
                <h2 className="text-display-lg font-display mb-5">
                    The detailer fabricators call when accuracy matters.
                </h2>
                <p className="text-lg text-steel-200 leading-relaxed">
                    Our staff has hands-on experience across modeling, detailing, fabrication, and erection.
                    That means our drawings anticipate the questions your shop floor would ask.
                </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-10 mb-20">
                {REASONS.map((reason) => (
                    <div key={reason.number} className="flex gap-5">
                        <span className="font-display text-3xl font-bold text-accent shrink-0 tabular-nums">
                            {reason.number}
                        </span>
                        <div>
                            <h3 className="text-xl font-bold mb-2 font-display">{reason.title}</h3>
                            <p className="text-steel-300 leading-relaxed">{reason.description}</p>
                        </div>
                    </div>
                ))}
            </div>

            <div className="pt-16 border-t border-white/10">
                <p className="text-sm font-semibold text-accent uppercase tracking-[0.2em] mb-8 text-center">How we work</p>
                <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                    {PROCESS.map((p, i) => (
                        <div key={p.step} className="relative">
                            <div className="flex items-center gap-3 mb-3">
                                <div className="w-8 h-8 rounded-full bg-accent text-navy-900 font-bold text-sm flex items-center justify-center">
                                    {i + 1}
                                </div>
                                <h4 className="text-lg font-bold font-display">{p.step}</h4>
                            </div>
                            <p className="text-sm text-steel-300 leading-relaxed">{p.detail}</p>
                            {i < PROCESS.length - 1 && (
                                <div className="hidden md:block absolute top-4 left-full w-full h-px bg-white/10 -translate-x-1/2" aria-hidden="true" />
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    </section>
);
